import { render } from "./companyTable.vue?vue&type=template&id=1e6f6dd9"
import script from "./companyTable.vue?vue&type=script&lang=js"
export * from "./companyTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__